/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

let configuredActions;

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return false;
  if (configuredActions === actions) return true;

  try {
    actions.updateCart.configure({
      eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
    });

    actions.openCart.configure({
      async handler() {
        /** @type {HTMLElement & {open?: () => void} | null} */
        const drawer = document.querySelector('theme-drawer#cart-drawer');

        if (drawer) {
          // On a cold cache, Shopify.actions can run before the drawer custom
          // element has upgraded. Wait for the existing drawer to become
          // operational instead of incorrectly treating it as absent and
          // navigating to the cart page.
          if (typeof drawer.open !== 'function') {
            await customElements.whenDefined('theme-drawer');
          }

          if (typeof drawer.open === 'function') {
            drawer.open();
            return;
          }
        }

        // The cart template intentionally has no drawer.
        window.location.href = Theme.routes.cart_url || '/cart';
      },
    });
  } catch (error) {
    console.warn('[cart-drawer] Shopify actions are not ready yet.', error);
    return false;
  }

  configuredActions = actions;
  return true;
}

// Shopify injects its standard-actions bundle through content_for_header.
// That bundle can finish either before or after DOMContentLoaded depending on
// network/cache state, so DOMContentLoaded alone is not a reliable readiness
// signal. Retry briefly and also check at the normal lifecycle boundaries.
if (!init()) {
  let attempts = 0;
  const maxAttempts = 300;
  const retryId = window.setInterval(() => {
    attempts += 1;
    if (init() || attempts >= maxAttempts) window.clearInterval(retryId);
  }, 50);

  document.addEventListener('DOMContentLoaded', init, { once: true });
  window.addEventListener('load', init, { once: true });
}
